import React from "react";
import ReactDOM from "react-dom/client";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { fr } from "date-fns/locale";
import "@/index.css";
import App from "@/App";

// Calendrier FR (lundi = 1er jour, noms des mois/jours en français)
registerLocale("fr", fr);
setDefaultLocale("fr");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
